import { action, observable } from 'mobx';
import { FILTER_DATA_MAP } from '../Constant/filterBarData';
import { RootStoreInterface } from './index';
import { qav } from '../Utils/qav';
export interface UiStateInterface {
    enableFilter: boolean;
    isShowFilterBar: boolean;
    filterBarTitle: string;
    sourceFrom: string;
    searchType:number;
    searchKey:string;
    searchTagKey:string;
    searchBusinessValue:string;
    searchOrderStatus:string;
    statusFilter: string;
    businessValue: string;
    businessId: string;
    isLogin: boolean;
    showLoginBar: boolean;

    isJourneyInnerModule: boolean;
    currentSelectedIndex: number;
    isOneLevelPage: boolean;
    isInCurrentPage: boolean;
    isBackFromOrderDetail: boolean;

    toggleShowLoginBar(showLoginBar: boolean): void;
    toggleEnableFilter(enableFilter: boolean): void;
    toggleFilterBarShow(isShowFilterBar?: boolean): void;
    updateFilterBarTitle(filterBarTitle: string): void;
    setSourceFrom(sourceFrom: string): void;
    setSearchType(searchType: number): void;
    setSearchKey(searchKey: string): void;
    setSearchTagKey(searchTagKey: string): void;
    setSearchBusinessValue(searchBusinessValue: string): void;
    setSearchOrderStatus(searchOrderStatus: string): void;
    setStatusFilter(statusFilter: string): void;
    setBusinessValue(businessValue: string): void;
    setBusinessId(businessId: string): void;
    setIsLogin(isLogin: boolean): void;
}

class UiState implements UiStateInterface {
    // 是否开启筛选栏功能
    @observable
    public enableFilter = false;

    // 是否展示筛选栏
    @observable
    public isShowFilterBar = false;

    // 筛选栏标题
    @observable
    public filterBarTitle = '';

    // 订单页面来源
    public sourceFrom = '';

    // 订单搜索类型：1模糊  0标签
    public searchType = 1;

    // 订单搜索模糊关键字
    public searchKey = '';

    // 订单搜索标签集合
    public searchTagKey = '';
    
    // 订单搜索标签集合
    public searchBusinessValue = '';

    // 订单搜索标签集合
    public searchOrderStatus = '';
    // 当前选中的状态栏
    @observable
    public statusFilter = 'all';

    @observable
    public businessValue = FILTER_DATA_MAP.all.value;

    @observable
    public businessId = 'all';

    @observable
    public isLogin = false;

    // 展示上方登录按钮条
    @observable
    public showLoginBar = false;

    public rootStore: RootStoreInterface;

    //是否为行程内置模块
    public isJourneyInnerModule = false;

    // 是否是行程一级页面
    public isOneLevelPage = true;

    //如果为行程内置模块，行程内tab目前选中下标(0为行程 1为订单)
    public currentSelectedIndex = 0;

    //是否处于当前页面(主要用于防止弹框在其他页面显示)
    public isInCurrentPage = true;

    // 是否从订单详情页面返回
    public isBackFromOrderDetail = false;

    public constructor(rootStore: RootStoreInterface) {
        this.rootStore = rootStore;
    }
    @action
    public toggleShowLoginBar = (showLoginBar: boolean) => {
        this.showLoginBar = showLoginBar;
        if (showLoginBar) {
            qav({
                page: this.rootStore.pageName,
                module: 'loginBtn',
                path: [{ title: '登录', position: '0' }],
                operType: 'show'
            });
        }
    };

    @action
    public toggleEnableFilter = (enableFilter: boolean) => {
        this.enableFilter = enableFilter;
    };

    @action
    public toggleFilterBarShow = (isShowFilterBar?: boolean) => {
        if (isShowFilterBar === undefined) {
            this.isShowFilterBar = !this.isShowFilterBar;
        } else {
            this.isShowFilterBar = isShowFilterBar;
        }
    };

    @action
    public updateFilterBarTitle = (filterBarTitle: string) => {
        this.filterBarTitle = filterBarTitle;
    };

    public setSourceFrom = (sourceFrom: string) => {
        this.sourceFrom = sourceFrom;
    };

    public setSearchType = (searchType: number) => {
        this.searchType = searchType;
    };

    public setSearchKey = (searchKey: string) => {
        this.searchKey = searchKey;
    };

    public setSearchTagKey = (searchTagKey: string) => {
        this.searchTagKey = searchTagKey;
    };

    public setSearchBusinessValue = (searchBusinessValue: string) => {
        this.searchBusinessValue = searchBusinessValue;
    };

    public setSearchOrderStatus = (searchOrderStatus: string) => {
        this.searchOrderStatus = searchOrderStatus;
    };

    @action
    public setStatusFilter = (statusFilter: string) => {
        this.statusFilter = statusFilter;
    };

    @action
    public setBusinessValue = (businessValue: string) => {
        this.businessValue = businessValue;
    };

    @action
    public setBusinessId = (businessId: string) => {
        this.businessId = businessId;
    };

    @action
    public setIsLogin = (isLogin: boolean) => {
        this.isLogin = isLogin;
    };
}

export default UiState;
